import { Icon } from '@mui/material';
import Image_4 from 'asset/cloud_image.png';
import Icon_1 from 'asset/icon_1.svg';
import Icon_2 from 'asset/icon_2.svg';
import Icon_3 from 'asset/icon_3.svg';
import Icon_4 from 'asset/icon_4.svg';
import imagePlaceholder from 'asset/image-placeholder.png';
import Image_2 from 'asset/mmv_image.png';
import Image_1 from 'asset/pr_image.png';
import Image_3 from 'asset/ui_image.png';

export const data_technology_behind = {
  prefix: 'technology behind',
  title: 'ACCELERATED by <span>NVIDIA Technology</span>',
  items: [
    {
      id: 1,
      icon: Icon_1,
      title: 'Photorealistic Rendering',
      description:
        'NVIDIA Omniverse RTX™ Renderer lets you experience high-fidelity, real-time visuals with stunning detail with industry-leading convergence of real-time and offline rendering.',
      image: Image_1,
    },
    {
      id: 2,
      icon: Icon_2,
      title: 'Multi-Mode Viewing',
      description:
        'Switch between mixed reality, Full VR, and Portal Mode for a customized experience in the NVIDIA Omniverse &mdash; with unmatched performance and realism.',
      image: Image_2,
    },
    {
      id: 3,
      icon: Icon_3,
      title: 'Intuitive and Secure UI',
      description:
        'Based in OpenUSD, SoftServe XR Design Pro lets you interact with virtual assets naturally with intuitive controls. Leverage seamless collaboration, non-destructive editing, and multiple views.',
      image: Image_3,
    },
    {
      id: 4,
      icon: Icon_4,
      title: 'Cloud-Powered XR Support',
      description:
        'NVIDIA CloudXR offloads rendering for seamless performance and scalability to support high-end XR devices like the Apple Vision Pro. That gives you the flexibility to offer workers and customers top–tier design experience &mdash; wherever they are. ',
      image: Image_4,
    },
  ],
};
